var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17191_91422)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F2"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 20C30 25.5227 25.5227 30 20 30C14.4773 30 10 25.5227 10 20C10 14.4773 14.4773 10 20 10C25.5227 10 30 14.4773 30 20ZM20.5488 14C18.2616 14 17.0895 15.4022 17 17.163H18.3919C18.4814 15.9973 19.2628 15.2717 20.4919 15.2717C21.7047 15.2717 22.486 16.0136 22.486 17.0245C22.486 17.8967 22.1198 18.4103 21.1756 18.9891C20.0605 19.6576 19.5395 20.3913 19.5477 21.4674V22.2174H20.9721V21.6875C20.9721 20.8315 21.2651 20.375 22.2988 19.7636C23.3407 19.1359 24 18.231 24 16.9511C24 15.2717 22.6 14 20.5488 14ZM19.2384 24.8668C19.2384 25.5272 19.7105 26 20.3698 26C21.0291 26 21.493 25.5272 21.493 24.8668C21.493 24.1984 21.0291 23.7255 20.3698 23.7255C19.7105 23.7255 19.2384 24.1984 19.2384 24.8668Z",
    fill: "#4251DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17191_91422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.0fb1863ea6bee87342fe7fea131c82e5.svg";
export { ForwardRef as ReactComponent };